// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// This can prevent double clicks on links and buttons, similar to `data-disable-with` from rails-ujs.
// rails-ujs is not available for elements that are handled by unpoly (e.g. with `up-follow`, `up-target`).
// The attribute value of `up-disable-with` will be used to replace the text of the element.
up.compiler('[up-disable-with]', (element) => {
  let linkClickedCount = 0

  function replaceLabel() {
    const replacement = element.getAttribute('up-disable-with')
    if (replacement != null) {
      element.innerHTML = replacement
    }
  }

  const unbindClickListener = up.on(element, 'click', (event) => {
    linkClickedCount += 1

    if (linkClickedCount === 1) {
      replaceLabel()
    } else {
      // any click after the first is aborted
      up.event.halt(event)
    }
  })

  // We want to disable the button only after the request was fired as a the `disabled` class
  // seems to mess up `method: :post`
  const unbindUpRequestLoadListener = up.on('up:request:load', function(event, _htmlElement) {
    if (event.origin === element) {
      // wait one tick to increase the chance the request started
      setTimeout(() => {
        element.classList.add('disabled')
      }, 0)
    }
  })

  return function() {
    unbindClickListener()
    unbindUpRequestLoadListener()
  }
})
